import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import { AuthContext } from '../../../../contexts/AuthContext';
import {
  Modules,
  AuthRoutes,
  PermissionModulesEnum,
  PermissionActionsEnum,
} from '../../../../enums';
import { hasResourseAccess } from '../../../../utils/methods';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasListAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.MonthlyStock]: [PermissionActionsEnum.View] }],
  });

  const handleGoToListClick = () => {
    navigate(Modules.monthlyStock + AuthRoutes.monthlyStockList);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('monthlyStock.addEdit.pageTexts.header.title')}</h4>
        <p>{t('monthlyStock.addEdit.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        <div>
          {hasListAccess && (
            <Button
              className="btn btn-primary waves-effect waves-light me-3"
              onClick={handleGoToListClick}
              text={t('monthlyStock.addEdit.pageTexts.header.goToList')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
